module.exports = __webpack_public_path__ + "assets/img/play.73dffaa2.svg";